<form [formGroup]="form" [attr.autocomplete]="'off'">
  <div class="price-reduction">
    <div class="form-row">
      <h2 class="form-headline">Prisreduktion</h2>
      @if (hasRights) {
        <div>
          <mat-slide-toggle color="primary" formControlName="fastPrisEnabled">Fast pris (årlig)</mat-slide-toggle>
        </div>
      }
    </div>
    @if (fixedPriceEnabled) {
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Fast pris (årlig)</mat-label>
          <input type="number" formControlName="fastPris" matInput />
        </mat-form-field>
      </div>
      <div class="form-row flex">
        <div class="form-row form-row--inline">
          <mat-form-field appearance="outline">
            <mat-label>Fast pris start</mat-label>
            <mat-datepicker-toggle matPrefix [for]="fixedPriceStartDatePicker"></mat-datepicker-toggle>
            <input
              #fixedPriceStartInput
              matInput
              [matDatepicker]="fixedPriceStartDatePicker"
              formControlName="fixedPriceStartDate"
              [min]="fixedPriceMinStartDate"
              />
              <mat-datepicker #fixedPriceStartDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="form-row form-row--inline">
            <mat-form-field appearance="outline">
              <mat-label>Fast pris udløb</mat-label>
              <mat-datepicker-toggle matPrefix [for]="fixedPriceEndDatePicker"></mat-datepicker-toggle>
              <input
                #fixedPriceEndDateInput
                matInput
                [matDatepicker]="fixedPriceEndDatePicker"
                formControlName="fixedPriceEndDate"
                [min]="minEndDate"
                />
                <mat-datepicker #fixedPriceEndDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        }

        <div class="form-row">
          <mat-slide-toggle color="primary" formControlName="rabatEnabled">Rabat (årlig)</mat-slide-toggle>
        </div>
        @if (rabatEnabled?.value) {
          <div class="form-row">
            <app-rabat-kampagne-form [rabatForm]="form" [isPrivatKunde]="isPrivatKunde"></app-rabat-kampagne-form>
          </div>
        }
      </div>
      @for (group of tilvalgGroups; track group; let i = $index) {
        <div formArrayName="tilvalgGroups" class="margin-top">
          <div class="form-row">
            <label class="form-headline">{{ group.name }}</label>
            <mat-radio-group formControlName="{{ i }}">
              @for (tilvalg of group.tilvalg; track tilvalg) {
                <mat-radio-button
                  [value]="tilvalg.tilvalgnr"
                  [disabled]="disableTilvalg(tilvalg)"
                  [matTooltip]="getToolTip(disableTilvalg(tilvalg))"
                  >
                  {{ tilvalg.name }}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        </div>
      }
    </form>
